function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "Resume"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C4C4C4",
  d: "M4.165 11.646L175.5 4l4.5 118L7.5 133 4.165 11.646z",
  className: "boxFill"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M176.992 1.404a2 2 0 01.65 1.406l4.183 119.8a2 2 0 01-1.881 2.066L7.445 134.83a1.997 1.997 0 01-2.116-1.927L1.124 12.477a2 2 0 011.888-2.067L175.533.883a2 2 0 011.459.52zM5.19 14.296l4.065 116.421 168.505-9.919L173.715 4.99 5.19 14.296z",
  className: "boxStroke",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  className: "ResumePaper"
}, /*#__PURE__*/React.createElement("g", {
  className: "lines"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M103.524 66.027a2.001 2.001 0 01-1.853 2.137l-28.105 2.002a2 2 0 01-.284-3.99l28.104-2.002a2.001 2.001 0 012.138 1.853z",
  className: "Vector 13 (Stroke)",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M104.022 80.303a2 2 0 01-1.853 2.137l-28.104 2.003a2 2 0 11-.285-3.99l28.105-2.003a2 2 0 012.137 1.853z",
  className: "Vector 14 (Stroke)",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M104.556 95.6a2 2 0 01-1.853 2.136L74.599 99.74a2 2 0 11-.284-3.99l28.104-2.003a2 2 0 012.137 1.853z",
  className: "Vector 15 (Stroke)",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M56.066 19.301l-2.044.07.116 2.043 5.308 93.234.117 2.054 2.05-.175 30.19-2.585 29.652-2.067 1.944-.135-.085-1.947-2.675-61.689.22-.007-2.891-3.192-10.311-11.38-10.31-11.382-3.403-3.755-.013-.387-37.865 1.3zm37.745 2.707l-35.563 1.22 5.075 89.138 28.155-2.411.016-.001.015-.002 27.724-1.932-2.592-59.776-.086.003-19.802.691-1.999.07-.07-1.999-.819-23.453-.054-1.548zm4.801 22.863l-.558-15.99 6.639 7.329 7.419 8.19-13.5.471z",
  className: "paper",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M81.55 48.347a6.834 6.834 0 001.46-4.503c-.128-3.66-3.031-6.53-6.485-6.41-3.454.12-6.15 3.186-6.022 6.847a6.834 6.834 0 001.763 4.38c-1.178.51-2.26 1.2-3.195 2.047-2.05 1.856-3.234 4.33-3.315 6.92a2 2 0 003.998.125c.044-1.427.699-2.9 2.002-4.08 1.316-1.193 3.168-1.96 5.196-2.042 2.028-.083 3.942.53 5.358 1.614 1.403 1.073 2.181 2.491 2.347 3.912a2 2 0 003.973-.464c-.3-2.574-1.69-4.943-3.89-6.625a11.685 11.685 0 00-3.19-1.721z",
  className: "guy",
  clipRule: "evenodd"
})));

function SvgResume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183,
    height: 135,
    fill: "none",
    viewBox: "0 0 183 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/Resume.ff407fae.svg";
export { ForwardRef as ReactComponent };